(() => {
  const moneyText = (picker) => picker.querySelector('input[type="radio"]:checked')?.dataset.cgPrice || '';

  const initBundlePicker = (picker) => {
    if (picker.dataset.cgReady === 'true') return;
    const productInfo = picker.closest('product-info');
    if (!productInfo) return;
    picker.dataset.cgReady = 'true';

    const syncSelection = () => {
      const selected = picker.querySelector('input[type="radio"]:checked');
      if (!selected) return;
      let mode = picker.dataset.cgBundleMode;
      const allowedVariantIds = new Set((picker.dataset.cgVariantIds || '').split(',').filter(Boolean));
      const selectedVariantId = selected.dataset.cgVariantId || '';
      if (mode === 'variants' && !allowedVariantIds.has(selectedVariantId)) mode = 'quantity';
      const forms = productInfo.querySelectorAll('product-form form[action*="/cart/add"]');

      forms.forEach((form) => {
        let quantityInput = form.querySelector('input[name="quantity"]');
        if (!quantityInput) {
          quantityInput = document.createElement('input');
          quantityInput.type = 'hidden';
          quantityInput.name = 'quantity';
          form.appendChild(quantityInput);
        }

        if (mode === 'variants') {
          const variantInput = form.querySelector('input[name="id"]');
          if (variantInput) {
            variantInput.value = selectedVariantId;
            variantInput.dispatchEvent(new Event('change', { bubbles: true }));
          }
          quantityInput.value = '1';
        } else {
          quantityInput.value = selected.dataset.cgQuantity || '1';
        }
      });

      if (mode === 'variants') {
        const price = productInfo.querySelector('.price-item--regular, .price-item--sale');
        if (price && moneyText(picker)) price.textContent = moneyText(picker);
      }
      document.querySelectorAll('.cg-mobile-atc__price').forEach((price) => {
        if (moneyText(picker)) price.textContent = moneyText(picker);
      });
    };

    picker.addEventListener('change', syncSelection);
    requestAnimationFrame(syncSelection);
  };

  const initStickyAddToCart = (sticky) => {
    if (sticky.dataset.cgReady === 'true') return;
    const mainButton = document.querySelector('.product-form__submit');
    const stickyButton = sticky.querySelector('[data-cg-sticky-button]');
    if (!mainButton || !stickyButton) return;
    sticky.dataset.cgReady = 'true';

    if ('IntersectionObserver' in window) {
      const visibilityObserver = new IntersectionObserver(([entry]) => {
        sticky.classList.toggle('is-visible', !entry.isIntersecting && entry.boundingClientRect.bottom <= 0);
      });
      visibilityObserver.observe(mainButton);
    }

    const mirrorButton = () => {
      stickyButton.disabled = mainButton.disabled;
      const sourceText = mainButton.querySelector('span')?.textContent?.trim();
      if (sourceText) stickyButton.textContent = sourceText;
    };

    stickyButton.addEventListener('click', () => {
      if (!mainButton.disabled) mainButton.click();
    });
    new MutationObserver(mirrorButton).observe(mainButton, { attributes: true, childList: true, subtree: true });
    mirrorButton();
  };

  const bindStoryButtons = () => {
    if (document.documentElement.dataset.cgStoryReady === 'true') return;
    document.documentElement.dataset.cgStoryReady = 'true';
    document.addEventListener('click', (event) => {
      const trigger = event.target.closest('[data-cg-story-add-to-cart]');
      if (!trigger) return;
      event.preventDefault();
      const button = document.querySelector('.product-form__submit');
      if (button && !button.disabled) button.click();
      else document.getElementById('MainProduct')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  };

  const initialize = (root = document) => {
    root.querySelectorAll('[data-cg-bundle]').forEach(initBundlePicker);
    root.querySelectorAll('[data-cg-mobile-atc]').forEach(initStickyAddToCart);
    bindStoryButtons();
  };

  document.addEventListener('DOMContentLoaded', () => initialize());
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
